import React from 'react';

function ButtonLoader() {
    return <span className='loader-btn'> </span>;
}

export default ButtonLoader;
